import StepThreeIcon from './component.jsx'
export default StepThreeIcon
